module.exports = __webpack_public_path__ + "img/TRAVEL-JP.3be683a7.jpg";